// src/pages/Withdraw/Withdraw.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import WithdrawMethod from './WithdrawMethod';
import BankWithdrawal from './BankWithdrawal';
import CryptoWithdrawal from './CryptoWithdrawal';

const Withdraw = () => {
  return (
    <Routes>
      <Route path="/" element={<WithdrawMethod />} />
      <Route path="/bank" element={<BankWithdrawal />} />
      <Route path="/crypto" element={<CryptoWithdrawal />} />
    </Routes>
  );
};

export default Withdraw;